export default {
  primary: {
    backgroundColor: 'primary',
    color: 'light',
    border: 'solid 2px',
    borderColor: 'primary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.8rem', '', '0.85rem'],
    padding: '1.25rem 2.5rem',
    minWidth: '200px',
    transition: 'all ease-in-out 0.5s',
    border: 'solid 1px white',
    borderRadius: '100px',
    transition: 'all .25s',
    ':hover': {
      backgroundColor: 'transparent',
      color: 'primary',
      borderColor: 'white',
      transition: 'all .25s'
    }
  },
  secondary: {
    background: 'transparent',
    color: 'light',
    border: 'solid 2px',
    borderColor: 'secondary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    transition: 'all ease-in-out 0.5s',
    borderRadius: '100px',
    ':hover': {
      backgroundColor: 'secondary',
      borderColor: 'white'
    }
  }
}
